<div id="wrap">
  
  <section id="header" app-user-header></section>
  
  <div id="controls" app-user-sidebar></div>
  
  <router-outlet></router-outlet>

  <section id="footer" app-user-footer></section>

</div>